var map = {
	"./ava_calendar.svg": 727,
	"./galeria_calendar.svg": 3692,
	"./jamh_calendar.svg": 2093,
	"./kbmo_calendar.svg": 2468,
	"./ktkh_calendar.svg": 1361,
	"./pmh_calendar.svg": 6408,
	"./szimh_calendar.svg": 8728
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7299;